import React from "react";

const BrandCtas = ({ctas}) => {
    return(
                        <div className="brand__header-cta">
                            {ctas.map((cta, index) => (
                                <a key={index} href={cta.cta_link} className="brand__cta-link" target={cta.cta_target || "_self"}>
                                    {cta.cta_text}
                                </a>
                            ))}
                        </div>
    )
}

export default BrandCtas;